import React, { useEffect } from "react";
import {
  Typography,
  Card,
  FormControl,
  RadioGroup,
  CardContent,
  FormControlLabel,
  TextField,
  Radio,
  IconButton,
  Divider,
  FormLabel,
  Button,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const Action = ({
  selectedAction,
  handleInputFieldOrderChange,
  inputFieldOrder,
  handleInputChange,
  handleRemoveInputField,
  handleAddInputField,
  recipientEmails,
  handleRecipientChange,
  handleRemoveRecipient,
  handleAddRecipient,
  handleAction,
  handleActionChange,
  inputFields,
  classes,
  emailError,
}) => {

   useEffect(() => {
    if (selectedAction !== "yourself" && inputFieldOrder.length === 0) {
      handleAddInputField();
    }
  }, [selectedAction, inputFieldOrder.length, handleAddInputField]);
  
  const validateEmail = (email) => {
    // A simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  return (
    <div>
      <div style={{ marginTop: "15px" }}>
        <Typography
          variant="h6"
          style={{
            "text-align": "left",
            "font-size": "16px",
            margin: "5px",
          }}
        >
          Choose an action
        </Typography>
        <Card
          style={{
            "margin-right": "1px",
            marginTop: "10px",
          }}
        >
          <CardContent>
            <FormControl
              style={{
                "font-size": "14px !important",
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="yourself"
                name="radio-buttons-group"
                onChange={handleActionChange}
                value={selectedAction}
              >
                <FormControlLabel
                  value="yourself"
                  control={<Radio />}
                  label="Sign a Document"
                />
                <FormControlLabel
                  value="signandsend"
                  control={<Radio />}
                  label="Sign & Send for Signature"
                />
                <FormControlLabel
                  value="send"
                  control={<Radio />}
                  label="Send for Signature"
                />
              </RadioGroup>
            </FormControl>

{/* 

            {selectedAction !== "yourself" && (
              <DragDropContext onDragEnd={handleInputFieldOrderChange}>
                <Droppable droppableId="inputFields">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        marginTop: "15px",
                      }}
                    >
                      {inputFieldOrder.map((index, idx) => (
                        <Draggable
                          key={index}
                          draggableId={`inputField-${index}`}
                          index={idx}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <TextField
                                fullWidth
                                label={`Name ${idx + 1}`}
                                name="name"
                                value={inputFields[index]?.name}
                                onChange={(e) => handleInputChange(index, e)} // Corrected this line
                                size="small"
                                style={{
                                  marginBottom: "10px",
                                  width: "80%",
                                  marginLeft: "20px",
                                }}
                                InputProps={{
                                  style: {
                                    fontSize: "14px",
                                  },
                                }} // Set font size here
                              />

                              <TextField
                                fullWidth
                                label={`Email ${idx + 1}`}
                                name="email"
                                value={inputFields[index]?.email}
                                onChange={(e) => handleInputChange(index, e)} // Corrected this line
                                size="small"
                                style={{
                                  marginBottom: "10px",
                                  width: "80%",
                                  marginLeft: "20px",
                                }}
                                InputProps={{
                                  style: { fontSize: "14px" },
                                }} // Set font size here
                              />
                              <div
                                className="arrow-icons"
                                style={{ alignItems: "center" }}
                              >
                                {idx !== 0 && (
                                  <ArrowUpwardIcon
                                    className="arrow-icon"
                                    fontSize="14"
                                  />
                                )}
                                {idx !== inputFieldOrder.length - 1 && (
                                  <ArrowDownwardIcon
                                    className="arrow-icon"
                                    fontSize="14"
                                  />
                                )}
                              </div>
                              {idx !== 0 && ( // Conditionally render the remove button for all except index 1
                                <IconButton
                                  aria-label="remove"
                                  onClick={() => handleRemoveInputField(index)}
                                >
                                  <RemoveCircleOutlineIcon />
                                </IconButton>
                              )}
                              {idx === inputFieldOrder.length - 1 && (
                                <IconButton
                                  aria-label="add"
                                  onClick={handleAddInputField}
                                >
                                  <AddCircleOutlineIcon />
                                </IconButton>
                              )}
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )} */}
  
      {selectedAction !== "yourself" && (
        <DragDropContext onDragEnd={handleInputFieldOrderChange}>
          <Droppable droppableId="inputFields">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ marginTop: "15px" }}
              >
                {inputFieldOrder.map((fieldId, index) => {
                  const fieldData = inputFields[fieldId];
                  return (
                    <Draggable
                      key={`field-${fieldId}`} 
                      draggableId={`field-${fieldId}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            marginBottom: "15px" 
                          }}
                        >
                          <TextField
                            fullWidth
                            label={`Name ${index + 1}`}
                            name="name"
                            value={fieldData?.name || ""}
                            onChange={(e) => handleInputChange(fieldId, e)}
                            size="small"
                            style={{ width: "80%", marginLeft: "20px" }}
                            InputProps={{ style: { fontSize: "14px" } }}
                          />
                          <TextField
                                fullWidth
                                label={`Email ${index + 1}`}
                                name="email"
                                value={fieldData?.email || ""}
                                onChange={(e) => handleInputChange(fieldId, e)} 
                                size="small"
                                style={{
                                  marginBottom: "10px",
                                  width: "80%",
                                  marginLeft: "20px",
                                }}
                                InputProps={{
                                  style: { fontSize: "14px" },
                                }} // Set font size here
                              />
                          
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {index !== 0 && (
                              <IconButton>
                                <ArrowUpwardIcon fontSize="14" />
                              </IconButton>
                            )}
                            {index !== inputFieldOrder.length - 1 && (
                              <IconButton>
                                <ArrowDownwardIcon fontSize="14" />
                              </IconButton>
                            )}
                            {inputFieldOrder.length > 1 && (
                              <IconButton onClick={() => handleRemoveInputField(fieldId)}>
                                <RemoveCircleOutlineIcon />
                              </IconButton>
                            )}
                            {index === inputFieldOrder.length - 1 && (
                              <IconButton onClick={handleAddInputField}>
                                <AddCircleOutlineIcon />
                              </IconButton>
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}

          </CardContent>
        </Card>
      </div>
      <Divider />
      <div style={{ marginTop: "15px" }}>
        <Typography
          variant="h6"
          style={{
            "text-align": "left",
            "font-size": "16px",
            margin: "5px",
          }}
        >
          Add Viewers
        </Typography>
        <br />
        <div>
          {recipientEmails?.map((email, index) => (
            <div key={index}>
              <TextField
                label={`Recipient Email   `}
                name={`recipient-${index}`}
                value={email}
                placeholder="Recipient Email"
                onChange={(e) => handleRecipientChange(index, e)}
                fullWidth
                size="small"
                style={{
                  marginBottom: "10px",
                  width: "80%",
                  marginLeft: "20px",
                }}
                error={
                  // (requiredError && email.trim() === "") ||
                  email && !validateEmail(email) ? !validateEmail(email) : false
                }
                InputProps={{
                  style: { fontSize: "14px"},
                }} // Set font size here
                helperText={
                  email && !validateEmail(email) ? "Invalid email address" : ""
                }
              />
              <IconButton
                aria-label="remove"
                onClick={() => handleRemoveRecipient(index)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </div>
          ))}
        </div>
        <IconButton
          aria-label="add"
          style={{
            border: "2px dotted #eee",
            borderRadius: "0px",
            width: "100%",
          }}
          onClick={handleAddRecipient}
        >
          <AddCircleOutlineIcon />
          <FormLabel style={{ paddingLeft: "10px" }}>Recipients</FormLabel>
        </IconButton>
      </div>
      <Divider />
      <div style={{ marginTop: "15px" }}>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          style={{ "border-radius": "5px", width: "95%" }}
          onClick={handleAction}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default Action;
